<ets-header [headerState]="HEADER_STATES.DASHBOARD" [isBGWhite]="true"></ets-header>
<div class="container">
  <ets-top-nav-bar></ets-top-nav-bar>
  <div class="inner">
    <router-outlet></router-outlet>
  </div>
</div>
